import { api_get, api_post } from "./utils"

const DedicatedAssignmentAPI = {
    fetchByIdentity: _fetchByIdentity,
    fetchByAssistantIdentity: _fetchByAssistantIdentity,
    supportAssign: _supportAssign,
    supportRemove: _supportRemove,
};


async function _fetchByIdentity(workKey: string, client_identity: string, cursor='') {
    if (!workKey) {
        return null;
    }
    const params = { identity: workKey, client_identity, cursor };
    return api_get("/dedicated-assignment/by-identity", params).then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });
}

async function _fetchByAssistantIdentity(identityKey: string, cursor='') {
    if (!identityKey) {
        return null;
    }
    return api_get("/dedicated-assignment/by-assistant-identity?assistant_identity=" + identityKey + '&cursor=' + cursor).then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });
}


async function _supportAssign(identityKey: string, assistantIdentityKey: string, ranking: string) {
    return api_post('/dedicated-assignment/support-assign',
        {identity: identityKey,
            assistant_identity: assistantIdentityKey,
            ranking: ranking
        })
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
        })
        .catch((err) => {
            console.error("Error assigning  clock: %o", err);
            throw err;
        });
}


async function _supportRemove(identityKey: string, assistantIdentityKey: string) {
    const data = {identity: identityKey,
        assistant_identity: assistantIdentityKey
    };
    return api_post('/dedicated-assignment/support-remove', data)
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
        })
        .catch((err) => {
            console.error("Error assigning  clock: %o", err);
            throw err;
        });
}



export default DedicatedAssignmentAPI;
